// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3rq9-","col":"CardReaderDesc_col__1SgP6","label":"CardReaderDesc_label__3odEO"};